"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _system = require("@ori-ui/mui-bundle/system");
var _xDataGridPro = require("@ori-ui/mui-bundle/x-data-grid-pro");
// taken from original mui styles
var SELECTED_OPACITY = 0.08;
var HOVER_OPACITY = 0.04;
var styleOverrides = {
    root: function(param) {
        var theme = param.theme;
        return {
            border: 0,
            color: theme.palette.text.primary,
            // Scrollbar
            '@media (hover: hover) and (pointer: fine)': {
                '&, & *': {
                    msOverflowStyle: '-ms-autohiding-scrollbar',
                    scrollbarWidth: 'thin',
                    scrollbarColor: "".concat(theme.palette.grey[300], " transparent")
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
                '::-webkit-scrollbar, & *::-webkit-scrollbar': {
                    width: 10,
                    height: 10
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
                '::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
                    background: 'transparent'
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
                '::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                    background: theme.palette.grey[300],
                    borderRadius: 6,
                    border: '2px solid transparent',
                    backgroundClip: 'content-box'
                }
            }
        };
    },
    columnHeaders: function(param) {
        var theme = param.theme;
        return {
            zIndex: 2,
            fontSize: '1.2rem',
            background: theme.palette.grey[50],
            borderBottom: "1px solid ".concat(theme.palette.grey[300]),
            boxShadow: '0px 1px 3px 0px rgba(51,51,51,0.2)'
        };
    },
    // pinnedColumnHeaders: {
    //   background: colors.oriGrey[50],
    //   [`&.${gridClasses['pinnedColumnHeaders--left']}`]: {
    //     borderRight: `1px solid ${colors.oriGrey[300]}`,
    //     boxShadow: '1px 0px 3px 0px rgba(51,51,51,0.2)',
    //   },
    //   [`&.${gridClasses['pinnedColumnHeaders--right']}`]: {
    //     borderLeft: `1px solid ${colors.oriGrey[300]}`,
    //     boxShadow: '-1px 0px 3px 0px rgba(51,51,51,0.2)',
    //   },
    // },
    // pinnedColumns: {
    //   [`&.${gridClasses['pinnedColumns--left']}`]: {
    //     borderRight: `1px solid ${colors.oriGrey[300]}`,
    //     boxShadow: '1px 0px 3px 0px rgba(51,51,51,0.2)',
    //   },
    //   [`&.${gridClasses['pinnedColumns--right']}`]: {
    //     borderLeft: `1px solid ${colors.oriGrey[300]}`,
    //     boxShadow: '-1px 0px 3px 0px rgba(51,51,51,0.2)',
    //   },
    // },
    row: function(param) {
        var theme = param.theme;
        var _obj;
        return {
            // stripe rows
            '&.odd': (_obj = {
                backgroundColor: theme.palette.grey[50]
            }, _define_property(_obj, "&:hover, &.".concat(_material.tableRowClasses.hover), {
                backgroundColor: (0, _system.alpha)(theme.palette.common.black, HOVER_OPACITY),
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }), _define_property(_obj, "&.".concat(_material.tableRowClasses.selected), _define_property({
                backgroundColor: (0, _system.alpha)(theme.palette.primary.main, SELECTED_OPACITY)
            }, "&:hover, &.".concat(_material.tableRowClasses.hover), {
                backgroundColor: (0, _system.alpha)(theme.palette.primary.main, SELECTED_OPACITY + HOVER_OPACITY),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (0, _system.alpha)(theme.palette.primary.main, SELECTED_OPACITY)
                }
            })), _obj)
        };
    },
    cell: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {
            // compare data
            '& .compareData': {
                flexGrow: 1
            },
            '& .compareData .secondary': {
                fontSize: '1.2rem',
                color: theme.palette.grey.A400
            },
            '& .compareData .negative': {
                color: theme.palette.error.dark
            },
            '& .compareData .positive': {
                color: theme.palette.success.dark
            }
        }, _define_property(_obj, "&.".concat(_xDataGridPro.gridClasses['cell--textRight'], " .compareData *"), {
            justifyContent: 'flex-end',
            textAlign: 'end'
        }), _define_property(_obj, "&.".concat(_xDataGridPro.gridClasses['cell--textCenter'], " .compareData *"), {
            justifyContent: 'center',
            textAlign: 'center'
        }), _obj;
    },
    footerContainer: function(param) {
        var theme = param.theme;
        return {
            borderTop: "1px solid ".concat(theme.palette.grey[300]),
            fontSize: '1.2rem',
            color: theme.palette.grey.A400,
            justifyContent: 'center'
        };
    }
};
var defaultProps = {
    hideFooterSelectedRowCount: true
};
var _default = exports.default = {
    styleOverrides: styleOverrides,
    defaultProps: defaultProps
}; //# sourceMappingURL=MuiDataGrid.js.map
